@layer module {
.email-text {
            overflow-wrap: anywhere;
    }

.email-text-part {
            display: inline-block;
    }
} // layer module
